module.exports = __webpack_public_path__ + "static/media/05.69017f1e.png";